namespace $ {

	export class $shm_hitalama_map_widget_entity_iframe extends $giper_baza_entity.with({

		Html_use: $giper_baza_atom_bool,

	}) {

		@ $mol_mem
		html_use( next?: boolean ) {
			return this.Html_use(next)?.val(next) ?? false
		}

	}

}
